export const autocompleteDelimiters = {
  preTag: 'highlight_start',
  postTag: 'highlight_stop',
};
